<div class="text-muted text-center p-4">
  <i class="fa-duotone fa-lock fa-10x mb-4"></i>
  <div class="text-lg">
    <p>{{ 'shared.general.notAuthorized' | translate }}</p>
    <p>{{ 'shared.general.notAuthorizedDescription' | translate }}</p>
  </div>
</div>
